(() => {
  const namespace = 'ValyouStoryLayout';

  const fitHeading = (heading) => {
    heading.style.removeProperty('font-size');
    heading.style.removeProperty('transform');
    heading.style.removeProperty('transform-origin');

    const originalSize = Number.parseFloat(window.getComputedStyle(heading).fontSize);
    const minSize = 12;
    let nextSize = originalSize;

    while (heading.scrollWidth > heading.clientWidth && nextSize > minSize) {
      nextSize -= 1;
      heading.style.fontSize = `${nextSize}px`;
    }

    if (heading.scrollWidth > heading.clientWidth && heading.clientWidth > 0) {
      const computed = window.getComputedStyle(heading);
      const textAlign = computed.textAlign;
      const origin = textAlign === 'center' ? 'center center' : textAlign === 'right' ? 'right center' : 'left center';

      heading.style.transform = `scaleX(${heading.clientWidth / heading.scrollWidth})`;
      heading.style.transformOrigin = origin;
    }
  };

  const fitAll = (root = document) => {
    root.querySelectorAll('[data-vsl-fit-heading]').forEach(fitHeading);
  };

  const scheduleFit = (root = document) => {
    window.clearTimeout(window[namespace].timer);
    window[namespace].timer = window.setTimeout(() => fitAll(root), 120);
  };

  if (window[namespace]) {
    window[namespace].fitAll();
    return;
  }

  window[namespace] = { fitAll, scheduleFit, timer: null };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fitAll(), { once: true });
  } else {
    fitAll();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => fitAll());
  }

  window.addEventListener('resize', () => scheduleFit(), { passive: true });
  document.addEventListener('shopify:section:load', (event) => scheduleFit(event.target));
})();
